import ShiftPattern from '@/components/ezuro/constants/shifts/edit/ShiftPattern.vue';
import TimeBetween from '@/components/ezuro/common/TimeBetween.vue'
import MinutesToText from '@/components/ezuro/common/MinutesToText.vue'
import Days from '@/components/ezuro/constants/shifts/edit/Days.vue';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import moment from 'moment';

const defaultEl = {
  id: null,
  name: '',
  company_id: '',
  department_id: '',
  division_id: '',
  abbreviation: '',
  type: 'days_one',
  time_start: '',
  time_end: '',
  length_in_minutes: 0,
  days: {
    1: true,
    2: true,
    3: true,
    4: true,
    5: true,
    6: false,
    7: false
  },
  employees: '',
  autofill_holidays: false,
  team_id: '',
  pattern: [],
  pattern_start: '',
  pattern_end: ''
};

export default {
  name: 'ShiftEdit',
  components: {
    Days,
    ShiftPattern,
    TimeBetween,
    MinutesToText
  },
  data () {
    return {
      editEl: defaultEl,
      isLoading: false
    }
  },
  validations: {
    editEl: {
      name: { required },
      company_id: { required },
      department_id: { required },
      division_id: { },
      abbreviation: { },
      type: { required },
      time_start: { },
      time_end: { },
      length_in_minutes: { },
      days: { },
      employees: { },
      autofill_holidays: { required },
      team_id: { },
      pattern: { },
      pattern_start: { },
      pattern_end: { }
    }
  },
  props: {
    editPerm: {
      type: String,
      default: 'edit-shifts'
    },
    basePath: {
      type: String,
      default: ''
    },
    isModal: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    companyOptions () {
      const visibleCompanies = this.$session.get('visible_companies').map(Number);
      const options = this.BasicHelper.sortArrayByKeyValue(
        this.$store.getters.getConfigOptions(
          'user_companies',
          this.$i18n.locale,
          'disabled',
          '0'
        ).filter(
          el => (
            visibleCompanies.includes(parseInt(el.value))
          )
        )
      );
      options.unshift({ value: null, text: '' });

      return options;
    },
    departmentOptions () {
      const departments = this.$store.getters.getConfigOptions(
        'company_departments',
        this.$i18n.locale,
        null, null, false, false, false,
        ['company_id']
      ).filter(
        el => (
          parseInt(this.editEl.company_id) == parseInt(el.company_id)
        )
      );

      return this.BasicHelper.sortArrayByKeyValue(departments, 'sortText');
    },
    divisionOptions () {
      const divisions = this.$store.getters.getConfigOptions(
        'company_divisions',
        this.$i18n.locale,
        null, null, false, false, false,
        ['company_id', 'department_id']
      ).filter(
        el => (
          parseInt(this.editEl.company_id) == parseInt(el.company_id) &&
          (this.editEl.department_id === null || parseInt(this.editEl.department_id) == parseInt(el.department_id))
        )
      );

      return this.BasicHelper.sortArrayByKeyValue(divisions, 'sortText');
    },
    typeOptions () {
      const types = [
        { value: 'days_one', text: this.$t('shift.type.options.days_one') },
        { value: 'days_many', text: this.$t('shift.type.options.days_many') },
        { value: 'pattern', text: this.$t('shift.type.options.pattern') }
      ];
      return types;
    },
    teamOptions () {
      const path = 'ezuro/teams/list?perPage=10000&department_id=' + this.editEl.department_id + '&division_id=' + (this.editEl.division_id ? this.editEl.division_id : 'null');
      const teams = [];
      this.isLoading = true;
      this.ApiRequest.request(path, this.ApiRequest.REQUEST_GET, {}, (response) => {
        if (response.data) {
          for (const team of response.data) {
            teams.push({ value: team.id, text: team.name });
          }
          this.isLoading = false;
        }
      });
      return teams;
    },
    baseTransParam () {
      return 'shift';
    },
    getTitle () {
      if (this.editEl.id) {
        return this.$t(`${this.baseTransParam}.actions.edit`);
      }
      return this.$t(`${this.baseTransParam}.actions.new`);
    },
    canEdit () {
      return !this.isLoading;
    }
  },
  methods: {
    show (elData) {
      this.v$.$reset();

      if (elData) {
        elData.company_id = this.$store.getters.getParamFromConfig('company_departments', elData.department_id, 'company_id');
        this.editEl = this.BasicHelper.cloneObject(elData);
        this.editEl.pattern = JSON.parse(this.editEl.pattern);

        if (this.editEl.type !== 'pattern') {
          const today = moment();
          this.editEl.time_end = new Date(today.format('YYYY-MM-DD') + ' ' + this.editEl.time_end);
          this.editEl.time_start = new Date(today.format('YYYY-MM-DD') + ' ' + this.editEl.time_start);
        }

        const daysObj = {
          1: false,
          2: false,
          3: false,
          4: false,
          5: false,
          6: false,
          7: false
        };

        for (const key in this.editEl.days) {
          if (typeof daysObj[this.editEl.days[key]] !== 'undefined') {
            daysObj[this.editEl.days[key]] = true;
          }
        }

        this.editEl.days = daysObj;
      } else {
        this.editEl = this.BasicHelper.cloneObject(defaultEl);
      }
      if (this.isModal) {
        this.$refs['modal-window'].show();
      }
    },
    handleTypeChange (type) {
      if (type == 'pattern') {
        this.editEl.pattern = [];
      }
    },
    updateDays (data) {
      this.editEl.days = data;
    },
    recheckAvailableTeams () {
      this.editEl.team_id = null;
    },
    save () {
      this.v$.$touch();
      if (!this.v$.$invalid && !this.isLoading) {
        this.isLoading = true;
        const reqData = { };
        for (const key of Object.keys(defaultEl)) {
          if (key === 'company_id') {
            continue;
          } else if (key === 'days') {
            let dataString = '';
            Object.keys(this.editEl.days).forEach(dayKey => {
              if (this.editEl.days[dayKey]) {
                dataString += dayKey;
              }
            });
            reqData[key] = dataString;
            continue;
          } else if (key === 'pattern') {
            reqData[key] = JSON.stringify(this.editEl[key]);
            continue;
          } else if (['time_start', 'time_end'].includes(key)) {
            reqData[key] = moment(this.editEl[key]).format('HH:mm');
            continue;
          } else if (key === 'pattern_start' || key === 'pattern_end') {
            reqData[key] = this.editEl[key] ? moment(this.editEl[key]).format('YYYY-MM-DD HH:mm') : null;
            continue;
          }
          reqData[key] = this.editEl[key];
        }
        this.ApiRequest.request(this.basePath + '/save' + (reqData.id ? '/' + reqData.id : ''), this.ApiRequest.REQUEST_POST, reqData, (response) => {
          if (response.error) {
            this.ApiRequest.displayErrorDialog(response, this);
          } else {
            this.$store.dispatch('reloadConfig');
            this.$emit('saved', response.data);
            this.close();
          }
          this.isLoading = false;
        });
      }
    },
    close () {
      if (this.isModal) {
        this.$refs['modal-window'].hide();
      }
    }
  },
  setup () {
    return { v$: useVuelidate() }
  }
}
